const images = [
	{
		title: "Muses Tanguent Image1",
		url: "https://i.ytimg.com/vi/d1-kbs9lVmM/maxresdefault.jpg",
	},
	{
		title: "Muses Tanguent Nature Image3",
		url: "https://cdn.honkfest.org/wp-content/images/Screen-Shot-2014-06-18-at-2.27.23-PM.png",
	},
	{
		title: "Muses Tanguent Nature Image4",
		url: "https://i1.sndcdn.com/avatars-000060014116-eum6e2-t500x500.jpg",
	},
];

export default images;
